<template>
  <Dropdown :hideArrow="true" :hasTooltip="true" tooltipType="page" ref="dropdown" pclass bclass="btn-block gp_dropdown-button" :positioning="positioning" :lclass="lclassDynamicClass">
    <template v-slot:button>
      <i :class="{ 'recent-pages': recentPages }">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.42631 8.79242C3.22109 8.84723 3.02711 8.95512 2.86612 9.11612C2.37796 9.60427 2.37796 10.3957 2.86612 10.8839C3.35427 11.372 4.14573 11.372 4.63388 10.8839C4.79488 10.7229 4.90277 10.5289 4.95758 10.3237C5.06894 9.90667 4.96105 9.44328 4.63388 9.11612C4.30672 8.78895 3.84333 8.68106 3.42631 8.79242Z" fill="#676767"/>
          <path d="M17.1339 10.8839C17.622 10.3957 17.622 9.60427 17.1339 9.11612C16.6457 8.62796 15.8543 8.62796 15.3661 9.11612C14.878 9.60427 14.878 10.3957 15.3661 10.8839C15.8543 11.372 16.6457 11.372 17.1339 10.8839Z" fill="#676767"/>
          <path d="M10.8839 9.11612C11.372 9.60427 11.372 10.3957 10.8839 10.8839C10.3957 11.372 9.60427 11.372 9.11612 10.8839C8.62796 10.3957 8.62796 9.60427 9.11612 9.11612C9.60427 8.62796 10.3957 8.62796 10.8839 9.11612Z" fill="#676767"/>
        </svg>
      </i>
      <!-- /===== Start Modal Share Social =====/ -->
      <ModalCommon @cancel="closeModal" classs="gf_modal-sm" v-if="isShowModalShareSocial" :hideExit="false">
        <template #header>
          <div class="gp_modal-container_header__title">{{ titleModal }}</div>
        </template>
        <template #default>
          <div class="share-container">
            <Notification 
              class="mb-2"
              type="infor"
              :htmlDesc="htmlDescNotification"
            >
            </Notification>
            <div class="share-item mb-1" @click="copyURL">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.2819 3.91458C13.6984 3.74202 14.1838 3.74202 14.6003 3.91458C14.9344 4.05304 15.1779 4.29987 15.5248 4.65169C15.5839 4.7116 15.646 4.77456 15.7121 4.84055C16.0349 5.16346 16.2163 5.60139 16.2163 6.05801C16.2163 6.51462 16.0349 6.95254 15.7121 7.27546L12.116 10.8721C11.9561 11.0321 11.7661 11.1591 11.5572 11.2457C11.1407 11.4183 10.6553 11.4183 10.2389 11.2457C9.90415 11.107 9.66064 10.8596 9.31319 10.5067C9.25449 10.447 9.19282 10.3844 9.12724 10.3187C8.88329 10.0745 8.48756 10.0743 8.24335 10.3183C7.99914 10.5622 7.99893 10.9579 8.24288 11.2021C8.29026 11.2496 8.3401 11.3009 8.39256 11.355C8.72757 11.7003 9.16944 12.1556 9.76037 12.4005C10.4832 12.7 11.3128 12.7 12.0357 12.4005C12.3963 12.2511 12.724 12.032 12.9999 11.756L16.596 8.15927C17.1532 7.60194 17.4663 6.8461 17.4663 6.05801C17.4663 5.26992 17.1533 4.51409 16.5961 3.95677C16.5485 3.90924 16.4981 3.85746 16.4454 3.80323C16.1105 3.45871 15.6686 3.0042 15.0787 2.75978C14.3559 2.46028 13.5263 2.46028 12.8035 2.75978C12.4429 2.9092 12.1152 3.12818 11.8393 3.40423L9.3498 5.89311C9.10569 6.13716 9.10564 6.53289 9.34969 6.777C9.59374 7.02111 9.98947 7.02115 10.2336 6.7771L12.723 4.28822C12.883 4.12823 13.073 4.00116 13.2819 3.91458Z" fill="#212121"/>
                <path d="M7.77963 9.32602C8.09196 9.01394 8.51543 8.83862 8.95697 8.83862C9.60807 8.83862 10.0272 9.21884 10.6736 9.86588C10.9175 10.1101 11.3133 10.1103 11.5575 9.86635C11.8017 9.6224 11.8019 9.22668 11.5579 8.98247L11.5126 8.93707C10.9279 8.3509 10.1675 7.58862 8.95697 7.58862C8.18395 7.58862 7.44258 7.8956 6.89583 8.44206L3.3876 11.9509C2.84117 12.4974 2.53418 13.2386 2.53418 14.0115C2.53418 14.7844 2.84115 15.5256 3.38758 16.0721L3.43365 16.1182C4.01829 16.7037 4.77864 17.4652 5.98837 17.4652C7.08168 17.4652 7.98122 16.806 8.67518 16.1406C9.0314 15.799 9.36261 15.4265 9.66111 15.0859L9.76819 14.9636C10.0295 14.6648 10.2601 14.4012 10.4782 14.1831C10.7222 13.9391 10.7222 13.5433 10.4782 13.2993C10.2341 13.0552 9.83836 13.0552 9.59428 13.2993C9.34438 13.5492 9.08348 13.8476 8.82679 14.1412L8.721 14.2621C8.42295 14.6022 8.12319 14.9381 7.81004 15.2383C7.16527 15.8566 6.57254 16.2152 5.98837 16.2152C5.33741 16.2152 4.91827 15.8351 4.27157 15.1884C3.95953 14.8762 3.78418 14.4529 3.78418 14.0115C3.78418 13.5701 3.95949 13.1468 4.27157 12.8347L7.77963 9.32602Z" fill="#212121"/>
              </svg>
              <p class="share-item__txt">{{ $t("share.copyURL") }}</p>
              <p class="typo-paragraph12 typo-italic ml-1" v-if="copied">Copied!</p>
            </div>
            <div class="share-item" @click="shareFB">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.75 10C18.75 5.16751 14.8325 1.25 10 1.25C5.16751 1.25 1.25 5.16751 1.25 10C1.25 14.3674 4.44975 17.9873 8.63281 18.6437V12.5293H6.41113V10H8.63281V8.07227C8.63281 5.87929 9.93914 4.66797 11.9378 4.66797C12.8952 4.66797 13.8965 4.83887 13.8965 4.83887V6.99219H12.7931C11.7062 6.99219 11.3672 7.66667 11.3672 8.35864V10H13.7939L13.406 12.5293H11.3672V18.6437C15.5503 17.9873 18.75 14.3674 18.75 10Z" fill="#1877F2"/>
                <path d="M13.406 12.5293L13.7939 10H11.3672V8.35864C11.3672 7.66667 11.7062 6.99219 12.7931 6.99219H13.8965V4.83887C13.8965 4.83887 12.8952 4.66797 11.9378 4.66797C9.93914 4.66797 8.63281 5.87929 8.63281 8.07227V10H6.41113V12.5293H8.63281V18.6437C9.53876 18.7854 10.4612 18.7854 11.3672 18.6437V12.5293H13.406Z" fill="white"/>
              </svg>
              <p class="share-item__txt">{{ $t("share.shareFB") }}</p>
            </div>
          </div>
        </template>
      </ModalCommon>
      <!-- /===== End Modal Share Social =====/ -->

      <template v-else>
        <Modal @cancel="closeModal" v-if="modelActive" classs="gp_modal-default" :hClass="hClassModal" :cClass="classModal" iClass="typo-icon-14" :mClass="bodyClassModal" :hideExit="false">
          <template #header>
            <p class="typo-heading16 typo-medium text-light-high" :class="{ 'text-danger': currentModel == 'delete', 'header-footer-title': currentModel === 'hnf' && !permission.headerFooter }">{{ titleModal }}</p>
          </template>
          <template #default>
            <!-- Body Duplicate -->
            <template v-if="['duplicate'].includes(currentModel)">
              <p class="typo-paragraph14 typo-regular-150 text-light-low">
                <template v-if="currentModel == 'duplicate'">{{ $t("generals.confirm.duplicate") }}</template>
                &nbsp;<span class="text-dark4">“{{ page.title }}”</span>?
              </p>
              <div class="col-12 p-0 mt-2">
                <div class="form-group">
                  <label class="label typo-button14 typo-medium text-light-high">{{ $t("generals.pageTitle") }}</label>
                  <input ref="inputTitle" v-focus class="input-field input-field-block" type="text" @keyup.enter="doSubmit" v-model="pageDublicateTitle" />
                  <p v-if="alertTextDuplicate" class="typo-paragraph12 typo-italic text-danger mt-half">{{ alertTextDuplicate }}</p>
                </div>
              </div>
            </template>
  
            <!-- Body Publish -->
            <template v-if="['publish'].includes(currentModel)">
              <p class="typo-paragraph14 typo-regular-150 text-light-low">
                <template v-if="currentModel == 'publish'">{{ $t("generals.confirm.publish") }}</template>
              </p>
              <!-- <p v-if="currentModel == 'publish' && ['productpages', 'collectionpages'].includes(pageType)" class="typo-paragraph14 typo-regular-150 text-light-low" v-html="delete2"></p> -->
            </template>
  
            <!-- Body unLink -->
            <template v-if="['unLink'].includes(currentModel)">
              <p class="typo-paragraph14 typo-regular-150 text-light-low">
                <template v-if="currentModel == 'unLink'">{{ $t("generals.confirm.unLink") }} ?</template>
              </p>
              <div class="modal-caution d-flex align-items-start mt-3">
                <svg class="" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.99996 10.6706C7.5468 10.6706 7.17944 11.0379 7.17944 11.4911C7.17944 11.9443 7.5468 12.3116 7.99996 12.3116C8.45311 12.3116 8.82047 11.9443 8.82047 11.4911C8.82047 11.0379 8.45311 10.6706 7.99996 10.6706Z" fill="#3C67FF" />
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99996 2.87177C8.45311 2.87177 8.82047 3.23912 8.82047 3.69228V8.95723C8.82047 9.41039 8.45311 9.77775 7.99996 9.77775C7.5468 9.77775 7.17944 9.41039 7.17944 8.95723V3.69228C7.17944 3.23912 7.5468 2.87177 7.99996 2.87177Z" fill="#3C67FF" />
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.4965 3.50353C10.0131 1.02019 5.98686 1.02019 3.50353 3.50353C1.02019 5.98686 1.02019 10.0131 3.50353 12.4965C5.98686 14.9798 10.0131 14.9798 12.4965 12.4965C14.9798 10.0131 14.9798 5.98686 12.4965 3.50353ZM2.34315 2.34315C5.46734 -0.781049 10.5327 -0.781049 13.6569 2.34315C16.781 5.46734 16.781 10.5327 13.6569 13.6569C10.5327 16.781 5.46734 16.781 2.34315 13.6569C-0.781049 10.5327 -0.781049 5.46734 2.34315 2.34315Z" fill="#3C67FF" />
                </svg>
                <span class="typo-paragraph14 typo-regular typo-lh150 pl-1">
                  {{ $t("generals.unlinkCaution") }}
                </span>
              </div>
            </template>
            <!-- Body Duplicate To -->
            <template v-if="['duplicateTo'].includes(currentModel)">
              <p class="typo-paragraph14 typo-regular-150 text-light-low break-word" v-html="$t('page.duplicateToDesc', { name: page.title })"></p>
            </template>
  
            <!-- Body Delete -->
            <template v-if="['delete'].includes(currentModel)">
              <div class="form-group">
                <p class="typo-paragraph14 typo-regular-150 text-light-low mb-1" v-html="$t('generals.confirm.delete', { name: page.title })"></p>
                <label class="mb-1 typo-paragraph14 typo-regular-150 text-light-low" v-html="$t('generals.confirm.typeConfirm')"></label>
                <input placeholder="Type here" ref="inputTitle" v-focus class="input-field input-field-block" type="text" @keyup.enter="doSubmit" v-model="retypeDelete" />
                <p v-if="alertText" class="typo-paragraph12 typo-italic text-danger mt-half">{{ alertText }}</p>
              </div>
            </template>
  
            <!-- Body Rename -->
            <template v-if="currentModel == 'rename'">
              <div class="col-12 p-0">
                <div class="form-group">
                  <!-- <label class="label typo-button14 typo-medium text-light-high">{{ $t("generals.pageTitle") }}</label> -->
                  <input ref="inputTitle" v-focus class="input-field input-field-block" type="text" @keyup.enter="doSubmit" v-model="pageTitle" />
                  <p v-if="alertText" class="typo-paragraph12 typo-italic text-danger mt-half">{{ alertText }}</p>
                </div>
              </div>
            </template>
  
            <!-- Body Move To New Group -->
            <template v-if="currentModel == 'moveNewGroup'">
              <div class="col-12 p-0">
                <div class="form-group">
                  <p class="mb-1 typo-paragraph14 typo-regular-150 text-light-low" v-html="$t('group.modalDesc')"></p>
                  <input :placeholder="$t('createNewGroup.placeholder')" ref="inputGroupName" v-focus class="input-field input-field-block" type="text" @keyup.enter="doSubmit" v-model="groupName" />
                  <p v-if="alertText" class="typo-paragraph12 typo-italic text-danger mt-half">{{ alertText }}</p>
                </div>
              </div>
            </template>
  
            <!-- Body Set Group -->
            <template v-if="currentModel == 'setgroup'">
              <div class=" p-0 mx-n4 mt-n1">
                <div class="group-list">
                  <div v-for="(g, index) in getGroups" :ref="'group_' + index" :key="index" :class="{ selected: g.id == selectedSetGroup.id }" class="group-item" @click="onClickSetGroup(g)">
                    <i class="icon icon-group"></i>
                    <div class="content">
                      <p class="title typo-button14 typo-medium text-light-high">{{ g.text }}</p>
                      <p class="desc typo-paragraph12 typo-regular text-light-low">{{ g.count }}</p>
                    </div>
                  </div>
                </div>
                <!-- <div class="form-group">
                  <label class="label typo-button14 typo-medium text-light-high">{{ $t("generals.selectGroup") }}</label>
                  <BaseSelect cclass="set-group-select" :value="selectedGroup" :options="getGroups" @input="onSetGroupID"></BaseSelect>
                </div>
                <p class="typo-paragraph12 typo-medium text-primary mt-2 text-align-right clickable" @click="moveToNewGroup">{{ $t("group.moveNewGroup") }}</p> -->
              </div>
            </template>
  
            <!-- Body Header & Footer -->
            <template v-if="currentModel == 'hnf'">
              <p class="typo-button14 typo-medium text-light-high" :class="{ 'header-footer-page-title-disable-child': !permission.headerFooter }">
                <b>{{ $t("generals.pageTitle") }}:</b> {{ page.title }}
              </p>
              <template v-if="permission.headerFooter">
                <div class="d-flex mt-3">
                  <p class="typo-button14 typo-medium text-light-high mr-1">{{ $t("generals.headerFooter") }}</p>
                </div>
                <div class="d-flex mt-2">
                  <div>
                    <!-- <Toggler class="mr-auto" v-model="headerFooter" @input="changeToggler" :disabled="shopInfo.plan == 'starter'" /> -->
                    <Toggler class="mr-auto" v-model="headerFooter" @input="changeToggler" />
                  </div>
                  <p class="typo-paragraph14 typo-italic text-light-low ml-3">{{ $t("page.toggleDesc") }}</p>
                </div>
                <div class="mt-2">
                  <div class="hf-image">
                    <img v-if="headerFooter" :src="publicPath + require('@/core/assets/setting/headerFooterOn.svg')" />
                    <img v-else :src="publicPath + require('@/core/assets/setting/headerFooterOff.svg')" />
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="d-flex header-footer-disable-toggle">
                  <p class="header-footer-label">{{ $t("generals.headerFooter") }}</p>
                  <div class="toggle-header-footer-disable">
                    <Toggler class="mr-auto" v-model="headerFooter" @input="changeToggler" :disabled="true" />
                  </div>
                </div>
                <div class="header-footer-content-upgrade">
                  <div>{{ $t("pricingOnboard.headerFooterDesc") }}</div>
                  <div class="desc2" v-html="headerFooterDesc2"></div>
                </div>
                <img class="full-image" :src="publicPath + require('@/core/assets/header_footer_onboarding.svg')" />
              </template>
            </template>
  
            <!-- Body Article Layout -->
            <template v-if="currentModel == 'articleLayout'">
              <p class="typo-button14 typo-medium text-light-high">
                <b>{{ $t("generals.pageTitle") }}:</b> {{ page.title }}
              </p>
              <div class="d-flex mt-3">
                <p class="typo-button14 typo-medium text-light-high mr-1">{{ $t("generals.modifyLayout") }}</p>
              </div>
              <div class="d-flex mt-2">
                <div>
                  <Toggler class="mr-auto" v-model="articleLayout" @input="changeTogglerArticle" />
                </div>
                <p v-if="articleLayout" class="typo-paragraph14 typo-italic text-light-low ml-3" v-html="$t('page.toggleModifyLayoutDescOn')"></p>
                <p v-else class="typo-paragraph14 typo-italic text-light-low ml-3" v-html="$t('page.toggleModifyLayoutDescOff')"></p>
              </div>
              <div class="mt-2">
                <div class="hf-image">
                  <img v-if="articleLayout" :src="publicPath + require('@/core/assets/setting/articleLayoutOn.svg')" />
                  <img v-else :src="publicPath + require('@/core/assets/setting/articleLayoutOff.svg')" />
                </div>
              </div>
            </template>

            <!-- Body Unpublish -->
            <template v-if="['unpublish'].includes(currentModel)">
              <div class="form-group">
                <p class="typo-paragraph14 typo-regular-150 text-light-high mb-1" v-html="unpublishDesc"></p>
                <p class="typo-paragraph14 typo-regular-150 text-light-high" v-html="$t('unpublish.areyousure')"></p>
              </div>
            </template>
  
          </template>
          <template #footer>
            <div class="form-group mt-2 mb-3" v-if="currentModel == 'duplicateTo'">
              <p class="typo-button14 typo-medium text-light-high label">{{ $t("page.selectPageType") }}</p>
              <Dropdown :hideArrow="true" ref="select-page-dropdown" class="select-page-dropdown" bclass lclass="gp-dropdown-duplicate-to">
                <template v-slot:button>
                  <p class="typo-body2 mr-2" :class="selectedType ? 'text-dark3' : 'text-secondary3'">{{ selectedPageType }}</p>
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.10229 4.14778L1.89779 3.35229L6.00004 7.45454L10.1023 3.35229L10.8978 4.14778L6.00004 9.04553L1.10229 4.14778Z" fill="#212121" />
                  </svg>
                </template>
  
                <div class="gp_dropdown-item" :class="item.key == selectedType.key ? 'active' : ''" v-for="item in pageTypeList" @click="onClickPageType(item)" :key="item.key">
                  <i :class="`icon icon-${item.key}`"></i>
                  <p class="typo-paragraph14 typo-regular text-light-high">{{ item.value }}</p>
                </div>
              </Dropdown>
              <template v-if="currentModel == 'duplicateTo'">
                <p v-if="alertText" class="typo-paragraph12 typo-italic text-danger mt-half">{{ alertText }}</p>
              </template>
              <div class="col-12 p-0 mt-2">
                <div class="form-group">
                  <label class="label typo-button14 typo-medium text-light-high">{{ $t("generals.pageTitle") }}</label>
                  <input ref="inputTitle" v-focus class="input-field input-field-block" type="text" @keyup.enter="doSubmit" v-model="pageDublicateToTitle" />
                  <p v-if="alertTextDuplicate" class="typo-paragraph12 typo-italic text-danger mt-half">{{ alertTextDuplicate }}</p>
                </div>
              </div>
            </div>
            <div class="btn-group flex-row-reverse">
              <!-- Footer -->
              <template v-if="['duplicate', 'duplicateTo', 'rename', 'hnf', 'articleLayout', 'setgroup', 'moveNewGroup', 'publish', 'unLink'].includes(currentModel)">
                <button class="btn btn-primary ml-1" @click="doSubmit">{{ textSubmitButton }}</button>
                <button class="btn btn-outline" @click="closeModal">{{ $t("generals.cancel") }}</button>
              </template>
  
              <template v-if="currentModel == 'delete'">
                <button class="btn btn-danger ml-1" @click="doSubmit">{{ textSubmitButton }}</button>
                <button class="btn btn-outline-danger" @click="closeModal">{{ $t("generals.cancel") }}</button>
              </template>
  
              <template v-if="currentModel == 'unpublish'">
                <button class="btn btn-danger ml-1" @click="doSubmit">{{ textSubmitButton }}</button>
                <button class="btn btn-outline" @click="closeModal">{{ $t("generals.cancel") }}</button>
              </template>
            </div>
          </template>
        </Modal>
      </template>
    </template>
    <component
      :is="disabledEdit || isRunningAbTesting ? 'div' : 'a'"
      class="gp_dropdown-setting d-flex align-items-center justify-content-between"
      :class="{ 'recent-pages__action': recentPages, disabled: disabledEdit || isRunningAbTesting }"
      :href="
        isGemPagesV7 
          ? editorV7Url
          : !(disabledEdit || isRunningAbTesting) ? page.editUrl : null"
      @click.stop="checkIsDefault"
    >
      <div class="d-flex align-items-center">
        <i class="icon icon-edit typo-icon-16 text-light-high"></i>
        <p class="typo-button14 ml-1">{{ $t("generals.edit") }}</p>
      </div>
    </component>

    <div
      class="gp_dropdown-setting d-flex align-items-center justify-content-between"
      :class="{ disabled: disabledMakeDefault }" v-if="['productpages', 'collectionpages'].includes(pageType)"
      @click.stop="clickMakeDefault"
    >
      <div class="d-flex align-items-center">
        <i class="icon icon-check-circle typo-icon-16 text-light-high"></i>
        <p class="typo-button14 ml-1">{{ defaultText }}</p>
      </div>
    </div>
    <div v-if="!isGemPagesV7" class="gp_dropdown-setting d-flex align-items-center" @click.stop="openPreview" :class="{ disabled: !showPreviewCondition }">
      <div class="d-flex align-items-center">
        <i class="icon icon-preview typo-icon-16 text-light-high"></i>
        <p class="typo-button14 ml-1">{{ $t("generals.preview") }}</p>
      </div>
    </div>
    <div class="gp_dropdown-setting d-flex align-items-center" @click.stop="openModal('hnf')" :class="{ disabled: isOriginalShopifyPage() }" v-if="!recentPages">
      <i class="icon icon-header-footer typo-icon-16 text-light-high"></i>
      <p class="typo-button14 ml-1">{{ $t("generals.headerFooter") }}</p>
      <div class="d-flex align-items-center justify-content-center ml-auto">
        <template v-if="headerFooter">
          <svg class="mr-half" width="4" height="5" viewBox="0 0 4 5" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="2" cy="2.5" r="2" fill="#3C67FF" />
          </svg>
          <p class="typo-paragraph12 typo-medium text-mono3">{{ $t("generals.on") }}</p>
        </template>
        <template v-else>
          <svg class="mr-half" width="4" height="5" viewBox="0 0 4 5" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="2" cy="2.5" r="2" fill="#9E9E9E" />
          </svg>
          <p class="typo-paragraph12 typo-medium text-light-disabled">{{ $t("generals.off") }}</p>
        </template>
      </div>
    </div>
    <div v-if="pageType == 'articlepages' && shopInfo.onlineStoreVersion == 'v1'" class="gp_dropdown-setting d-flex align-items-center" @click.stop="openModal('articleLayout')" :class="{ disabled: !page.isGpTemplate }">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.6999 16C3.5999 16 3.4999 16 3.3999 15.9C3.1999 15.8 3.0999 15.5 3.1999 15.3L5.8999 9H3.8999C3.6999 9 3.3999 8.9 3.1999 8.7C2.9999 8.5 2.8999 8.3 2.8999 8C2.8999 7.9 2.8999 7.7 2.9999 7.6L6.0999 0.6C6.1999 0.2 6.5999 0 6.9999 0H12.0999C12.3999 0 12.5999 0.1 12.7999 0.3C12.9999 0.5 13.0999 0.7 13.0999 1C13.0999 1.2 12.9999 1.4 12.8999 1.6L10.1999 5H12.4999C13.0999 5 13.4999 5.4 13.4999 6C13.4999 6.3 13.3999 6.5 13.1999 6.7L3.9999 15.9C3.8999 15.9 3.7999 16 3.6999 16ZM5.8999 8C5.9999 8 6.1999 8 6.2999 8.1C6.7999 8.3 6.9999 8.9 6.7999 9.4L5.0999 13.3L12.4999 6H10.1999C9.9999 6 9.7999 5.9 9.5999 5.8C9.1999 5.5 9.0999 4.8 9.3999 4.4L12.0999 1H6.9999L3.8999 8H5.8999Z" fill="#212121" />
      </svg>

      <p class="typo-button14 ml-1">{{ $t("generals.modifyLayout") }}</p>
      <div class="d-flex align-items-center justify-content-center ml-auto">
        <template v-if="articleLayout">
          <svg class="mr-half" width="4" height="5" viewBox="0 0 4 5" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="2" cy="2.5" r="2" fill="#3C67FF" />
          </svg>
          <p class="typo-paragraph12 typo-medium text-mono3">{{ $t("generals.on") }}</p>
        </template>
        <template v-else>
          <svg class="mr-half" width="4" height="5" viewBox="0 0 4 5" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="2" cy="2.5" r="2" fill="#9E9E9E" />
          </svg>
          <p class="typo-paragraph12 typo-medium text-light-disabled">{{ $t("generals.off") }}</p>
        </template>
      </div>
    </div>
    <div class="gp_dropdown-setting d-flex align-items-center" @click.stop="openModal('rename')" :class="{ disabled: isOriginalShopifyPage() || isDefault() || notAllow || isRunningAbTesting }">
      <i class="icon icon-rename typo-icon-16 text-light-high"></i>
      <p class="typo-button14 ml-1">{{ $t("generals.rename") }}</p>
    </div>
    <div class="gp_dropdown-setting d-flex align-items-center" :class="{ disabled: isOriginalShopifyPage() }" @click.stop="openModal('duplicate')" v-if="!recentPages">
      <i class="icon icon-duplicate typo-icon-16 text-light-high"></i>
      <p class="typo-button14 ml-1">{{ $t("generals.duplicate") }}</p>
    </div>
    <div class="gp_dropdown-setting d-flex align-items-center" :class="{ disabled: disabledDuplicateTo() }" @click.stop="openModal('duplicateTo')" v-if="!recentPages">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.31149 1.00134C4.17916 1.00134 3.94995 1.15267 3.94995 1.50134V12.5013C3.94995 12.85 4.17916 13.0013 4.31149 13.0013H13.7884C13.9207 13.0013 14.15 12.85 14.15 12.5013V1.50134C14.15 1.15267 13.9207 1.00134 13.7884 1.00134H4.31149ZM2.94995 1.50134C2.94995 0.745451 3.4922 0.00134277 4.31149 0.00134277H13.7884C14.6077 0.00134277 15.15 0.745451 15.15 1.50134V12.5013C15.15 13.2572 14.6077 14.0013 13.7884 14.0013H4.31149C3.4922 14.0013 2.94995 13.2572 2.94995 12.5013V1.50134Z" fill="#212121" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.34998 1.99866C1.62612 1.99866 1.84998 2.22251 1.84998 2.49866V14.4987C1.84998 14.8473 2.07918 14.9987 2.21151 14.9987H12.55C12.8261 14.9987 13.05 15.2225 13.05 15.4987C13.05 15.7748 12.8261 15.9987 12.55 15.9987H2.21151C1.39222 15.9987 0.849976 15.2546 0.849976 14.4987V2.49866C0.849976 2.22251 1.07383 1.99866 1.34998 1.99866Z" fill="#212121" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 3H6V5H12V3ZM6 2C5.44772 2 5 2.44772 5 3V5C5 5.55228 5.44772 6 6 6H12C12.5523 6 13 5.55228 13 5V3C13 2.44772 12.5523 2 12 2H6Z" fill="#212121" />
      </svg>

      <p class="typo-button14 ml-1">{{ $t("generals.duplicateTo") }}..</p>
    </div>
    <div v-if="!['productpages', 'collectionpages'].includes(pageType) && !recentPages" class="gp_dropdown-setting d-flex align-items-center" @click.stop="openModal('setgroup')" :class="{ disabled: isOriginalShopifyPage() }">
      <i class="icon icon-move typo-icon-16 text-light-high"></i>
      <p class="typo-button14 ml-1">{{ $t("generals.moveToGroup") }}</p>
    </div>
    <div class="gp_dropdown-setting d-flex align-items-center" :class="{ disabled: disabledShare }" @click.stop="openModal('share')" v-if="!recentPages">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 6C3.22386 6 3 6.22386 3 6.5V14.5C3 14.7761 3.22386 15 3.5 15H12.5C12.7761 15 13 14.7761 13 14.5V6.5C13 6.22386 12.7761 6 12.5 6H11.5C11.2239 6 11 5.77614 11 5.5C11 5.22386 11.2239 5 11.5 5H12.5C13.3284 5 14 5.67157 14 6.5V14.5C14 15.3284 13.3284 16 12.5 16H3.5C2.67157 16 2 15.3284 2 14.5V6.5C2 5.67157 2.67157 5 3.5 5H4.5C4.77614 5 5 5.22386 5 5.5C5 5.77614 4.77614 6 4.5 6H3.5Z" fill="#212121" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 0C8.27614 0 8.5 0.223858 8.5 0.5V7.5C8.5 7.77614 8.27614 8 8 8C7.72386 8 7.5 7.77614 7.5 7.5V0.5C7.5 0.223858 7.72386 0 8 0Z" fill="#212121" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.64645 0.146447C7.84171 -0.0488155 8.15829 -0.0488155 8.35355 0.146447L10.8536 2.64645C11.0488 2.84171 11.0488 3.15829 10.8536 3.35355C10.6583 3.54882 10.3417 3.54882 10.1464 3.35355L8 1.20711L5.85355 3.35355C5.65829 3.54882 5.34171 3.54882 5.14645 3.35355C4.95118 3.15829 4.95118 2.84171 5.14645 2.64645L7.64645 0.146447Z" fill="#212121" />
      </svg>
      <p class="typo-button14 ml-1">{{ $t("generals.share") }}</p>
    </div>

    <div class="gp_dropdown-setting d-flex align-items-center" @click.stop="openModal('unpublish')" :class="{ disabled: isDisabledUnpublish }" v-if="!recentPages">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.80078 2.375C2.80078 1.60242 3.44095 1 4.20078 1H11.4008C12.1606 1 12.8008 1.60242 12.8008 2.375V8.5C12.8008 8.77614 12.5769 9 12.3008 9C12.0246 9 11.8008 8.77614 11.8008 8.5V2.375C11.8008 2.18108 11.6351 2 11.4008 2H4.20078C3.9665 2 3.80078 2.18108 3.80078 2.375V8.5C3.80078 8.77614 3.57692 9 3.30078 9C3.02464 9 2.80078 8.77614 2.80078 8.5V2.375ZM4.69687 10C5.07735 10 5.39318 10.2762 5.56333 10.6165C5.97343 11.4368 6.82133 12 7.80078 12C8.78023 12 9.62813 11.4368 10.0382 10.6165C10.2084 10.2762 10.5242 10 10.9047 10H14.0008C14.4426 10 14.8008 10.3582 14.8008 10.8V14.2C14.8008 14.6418 14.4426 15 14.0008 15H1.60078C1.15895 15 0.800781 14.6418 0.800781 14.2V10.8C0.800781 10.3582 1.15895 10 1.60078 10H4.69687ZM1.80078 11V14H13.8008V11H10.9739L10.9703 11.0044C10.9576 11.0201 10.9444 11.0402 10.9327 11.0637C10.3597 12.2096 9.17347 13 7.80078 13C6.42809 13 5.24182 12.2096 4.66889 11.0637C4.65717 11.0402 4.64395 11.0201 4.63129 11.0044L4.62767 11H1.80078ZM9.8942 3.93658C8.91203 2.95441 7.31963 2.95441 6.33746 3.93658C5.35529 4.91875 5.35529 6.51116 6.33746 7.49332C7.31963 8.47549 8.91203 8.47549 9.8942 7.49332C10.8764 6.51116 10.8764 4.91875 9.8942 3.93658ZM6.90668 4.5058C7.47642 3.93606 8.34838 3.85238 9.00671 4.25485L6.65572 6.60584C6.25326 5.9475 6.33694 5.07554 6.90668 4.5058ZM9.32498 6.9241C8.75524 7.49384 7.88328 7.57753 7.22495 7.17506L9.57594 4.82407C9.9784 5.4824 9.89472 6.35437 9.32498 6.9241Z" fill="#F44336" />
      </svg>
      <p class="typo-button14 ml-1 text-danger">{{ $t("downgrade.unPublish.modal.btnText", { pageCount: null }) }}</p>
    </div>

    <!-- button: "Delete" -->
    <div class="gp_dropdown-setting d-flex align-items-center justify-content-between" :class="{ disabled: isOriginalShopifyPage() || isDefault() || notAllow || isRunningAbTesting || (isGemPagesV7 && page.status === 'PUBLISHED'), 'mt-1': recentPages }" @click.stop="openModal('delete')">
      <div class="d-flex align-items-center">
        <i class="icon icon-delete typo-icon-16 text-danger"></i>
        <p class="typo-button14 ml-1 text-danger">{{ $t("generals.delete") }}</p>
      </div>
    </div>

    <div v-if="['subpages', 'articlepages'].includes(pageType) && page.isGpTemplate && !page.gp_unlink" class="gp_dropdown-setting gp_dropdown-setting-border-bottom d-flex align-items-center" @click.stop="openModal('unLink')" :class="{ disabled: isOriginalShopifyPage() }">
      <!-- <i class="icon icon-move typo-icon-16 text-light-high"></i> -->
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 11.5C0.5 10.6716 1.17157 10 2 10H4.55467C4.73416 10 4.89988 10.0962 4.98888 10.2521C5.29628 10.7905 5.74242 11.2366 6.28083 11.544C7.94382 12.4935 10.0617 11.9151 11.0111 10.2521C11.1001 10.0962 11.2658 10 11.4453 10H14C14.8284 10 15.5 10.6716 15.5 11.5V14.5C15.5 15.3284 14.8284 16 14 16H2C1.17157 16 0.5 15.3284 0.5 14.5V11.5ZM2 11C1.72386 11 1.5 11.2239 1.5 11.5V14.5C1.5 14.7761 1.72386 15 2 15H14C14.2761 15 14.5 14.7761 14.5 14.5V11.5C14.5 11.2239 14.2761 11 14 11H11.7245C10.4374 12.9474 7.84131 13.5865 5.78501 12.4125C5.17721 12.0654 4.66067 11.5812 4.27568 11H2Z" fill="#3C67FF" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 1.5C2.5 0.671573 3.17157 2.98023e-08 4 0H12C12.8284 0 13.5 0.671573 13.5 1.5V8.5C13.5 8.77614 13.2761 9 13 9C12.7239 9 12.5 8.77614 12.5 8.5V1.5C12.5 1.22386 12.2761 1 12 1H4C3.72386 1 3.5 1.22386 3.5 1.5V8.5C3.5 8.77614 3.27614 9 3 9C2.72386 9 2.5 8.77614 2.5 8.5V1.5Z" fill="#3C67FF" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5 3.5C5 3.22386 5.22386 3 5.5 3H7.5C7.77614 3 8 3.22386 8 3.5C8 3.77614 7.77614 4 7.5 4H5.5C5.22386 4 5 3.77614 5 3.5Z" fill="#3C67FF" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5 5.5C5 5.22386 5.22386 5 5.5 5H10.5C10.7761 5 11 5.22386 11 5.5C11 5.77614 10.7761 6 10.5 6H5.5C5.22386 6 5 5.77614 5 5.5Z" fill="#3C67FF" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5 7.5C5 7.22386 5.22386 7 5.5 7H10.5C10.7761 7 11 7.22386 11 7.5C11 7.77614 10.7761 8 10.5 8H5.5C5.22386 8 5 7.77614 5 7.5Z" fill="#3C67FF" />
      </svg>

      <p class="typo-button14 ml-1 text-mono3">{{ $t("generals.unlinkGempage") }}</p>
    </div>
  </Dropdown>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import copyToClipboard from "@/utils/copyToClipboard.js";
import errorHandle from "@/mixins/errorHandle";
import { getPageListName } from "@/store/page/actions";
import { PAGE_EVENTS } from "@/contants/page";
import { pageApi } from "@/services";
import Config from "@/config";
import { getThemeId } from "@/modules/Instant/utils";

export default {
  name: "PageItemDropdown",
  mixins: [errorHandle()],
  props: {
    page: Object,
    positioning: {
      type: Boolean,
      default: true
    },
    pageType: String,
    whereAmI: String,
    total: Number,
    recentPages: {
      type: Boolean,
      default: false
    },
    notAllow: {
      type: Boolean,
      default: false
    },
    pageDefaultTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      modelActive: false,
      currentModel: "",
      headerFooter: false,
      articleLayout: false,
      pageTitle: "",
      pageDublicateTitle: "",
      textDefault: {
        "Theme Product Template": this.$t("page.defaultShopifyTemplate"),
        "Theme Collection Template": this.$t("page.defaultShopifyTemplate"),
        "Theme Index Template": this.$t("page.defaultShopifyTemplate"),
        "Your first Homepage": this.$t("page.defaultShopifyTemplate")
      },
      makeDefaultPages: ["template-collection", "template-index", "template-product"],
      selectedGroupID: null,
      groupName: "",
      copied: false,
      alertText: "",
      alertTextDuplicate: "",
      retypeDelete: "",
      selectedSetGroup: {},
      selectedType: "",
      headerFooterDesc2: this.$t("pricingOnboard.headerFooterDesc2"),
      themeID: null,
    };
  },
  computed: {
    ...mapState("page", {}),
    ...mapState("account", {
      shopInfo: "shopInfo",
      permission: state => state.permissions
    }),
    ...mapGetters("account", {
      displayLanguage: "displayLanguage"
    }),
    ...mapGetters("page", {
      pageTypeStatus: "pageTypeStatus"
    }),
    ...mapGetters("group", {
      groups: "groups"
    }),
    selectedPageType() {
      if (!this.selectedType) {
        return this.$t("page.selectPageType");
      }
      return this.selectedType.value;
    },
    lclassDynamicClass() {
      const classList = [];
      if (this.recentPages) {
        classList.push("recent-pages");
      }
      if (!this.recentPages && this.displayLanguage == "fr") {
        classList.push("fr");
      }

      return classList.join(" ");
    },
    pageTypeList() {
      let pType = this.pageType;
      if (pType == "subpages") {
        pType = "landingpages";
      }
      if (pType == "articlepages") {
        pType = "blog";
      }
      let list = [
        {
          key: "landingpages",
          value: "Landing Page"
        },
        {
          key: "homepages",
          value: "Home Page"
        },
        {
          key: "productpages",
          value: "Product Page"
        },
        {
          key: "collectionpages",
          value: "Collection Page"
        },
        {
          key: "blog",
          value: "Blog Post"
        }
      ];
      return list.filter(e => e.key != pType);
    },
    bodyClassModal() {
      if (this.currentModel == "duplicateTo") {
        return "p-2";
      }
      if (!this.permission?.headerFooter) {
        return "header-footer-not-avaible-body";
      }
      return "p-2";
    },
    hClassModal() {
      if (!this.permission?.headerFooter) {
        return "header-footer-not-avaible-header";
      }
      return "";
    },
    defaultText() {
      if (this.isBackToOriginal()) {
        return this.$t("page.backOriginal");
      } else {
        return this.$t("generals.makeDefault");
      }
    },
    delete2() {
      let type = this.$tc("page.collectionLower", 1);
      if (this.pageType == "productpages") {
        type = this.$tc("page.productLower", 1);
      }
      return this.$t("generals.confirm.delete2", { type: type, type2: this.$tc("page.product", 1) });
    },
    getGroups() {
      let groups = this.groups(this.pageType).map(e => ({
        id: e.id,
        value: e.id,
        text: e.name,
        count: e.count > 1 ? e.count + " pages" : e.count + " page"
      }));
      if (this.page.page_group_id) {
        groups.unshift({
          id: 0,
          value: 0,
          text: this.$t("group.none"),
          count: this.$t("group.noGroup")
        });
      }
      groups = groups.filter(e => e.id != this.page.page_group_id);
      return groups;
    },
    classModal() {
      if (this.currentModel == "hnf") {
        return "mw424";
      }
      return "mw222";
    },
    selectedGroup() {
      return this.page.page_group_id;
    },
    titleModal() {
      switch (this.currentModel) {
        case "duplicate":
          return this.$t("generals.duplicate");
        case "duplicateTo":
          return this.$t("generals.duplicateTo") + "...";
        case "delete":
          return this.$t("generals.delete");
        case "settings":
          return this.$tc("generals.setting", 2);
        case "rename":
          return this.$t("generals.renameThisPage") || this.$t("generals.rename");
        case "hnf":
          return this.permission.headerFooter ? this.$t("generals.headerFooter") : this.$t("pricing.headerFooterNotAvaible");
        case "articleLayout":
          return this.$t("generals.modifyLayout");
        case "setgroup":
          return this.$t("generals.moveToGroup");
        case "moveNewGroup":
          return this.$t("group.createNew");
        case "share":
          return this.$t("generals.sharePage");
        case "publish":
          return this.$t("generals.publish");
        case "unLink":
          return this.$t("generals.unlinkGempage");
        case "makeDefault":
          // return `"${this.$t("generals.makeDefault")}" ${this.$t("generals.confirmation")}`;
          return this.$t("generals.confirmation");
        case "unpublish":
          return this.$t("generals.unpublishConfirmation")
      }
      return "";
    },
    textSubmitButton() {
      switch (this.currentModel) {
        case "duplicate":
          return this.$t("generals.duplicate");
        case "duplicateTo":
          return this.$t("generals.duplicate");
        case "delete":
          return this.$t("generals.delete");
        case "rename":
          return this.$t("generals.apply");
        case "hnf":
          return this.permission.headerFooter ? this.$t("generals.save") : this.$t("dataNewPlan.upgradePlan");
        case "articleLayout":
          return this.$t("generals.save");
        case "setgroup":
          return this.$t("generals.move");
        case "moveNewGroup":
          return this.$t("generals.create");
        case "makeDefault":
          return this.$t("generals.makeDefault");
        case "unLink":
          return this.$t("generals.unlinkGempage");
        case "unpublish":
          return this.$t("generals.unpublish");
      }
      return "";
    },
    togglerHeaderFooter() {
      return this.page.pageLayout == "default" ? true : false;
    },
    isRunningAbTesting() {
      return this.page.runningCampaignId > 0;
    },
    disabledEdit() {
      return this.isOriginalShopifyPage() || this.notAllow;
    },
    disabledMakeDefault() {
      return this.isDefault() || this.isRunningAbTesting;
    },
    showPreviewCondition() {
      if (this.isOriginalShopifyPage() && !["productpages", "collectionpages", "homepages"].includes(this.pageType)) return false;
      if (this.pageType == "subpages") {
        if (!this.page.isGpTemplate || this.page.gp_unlink) return false;
      }
      if (this.pageType == "articlepages") {
        if (!this.page.isGpTemplate || this.page.gp_unlink) return false;
      }
      if (this.page.previewUrl) return true;
      return false;
    },
    /**
     * Page is shareable if it has viewliveUrl
     */
    disabledShare() {
      // disable share to "subpages", "articlepages", "homepages" isn't default || doesn't have viewliveUrl
      if (["subpages", "articlepages", "homepages"].includes(this.pageType)) {
        return !this.page.published || !this.page.viewliveUrl;
      }

      // disable share to "productpages", "collectionpages" isn't assigned to any products || collections
      if (["collectionpages"].includes(this.pageType)) {
        return !this.page.assigns?.length;
      }

      if (["productpages"].includes(this.pageType)) {
        return this.page.assignmentCount === 0 || !this.page.is_published;
      }

      return true;
    },
    isDisabledUnpublish() {
      return this.isDefault() || this.isOriginalShopifyPage() || this.isRunningAbTesting || !this.page.is_published || (!this.page.is_published && this.isPublishScheduled) || (["subpages", "articlepages"].includes(this.pageType) && !this.page.isGpTemplate);
    },
    unpublishDesc () {
      let des = this.$t('unpublish.headDesc') + ' ';
      switch (this.pageType) {
        case 'homepages':
          des += this.$t('unpublish.homePagesDesc', {pageDefaultTitle: this.pageDefaultTitle})
          break;
        case 'productpages':
          des += this.$t('unpublish.productPagesDesc', {pageDefaultTitle: this.pageDefaultTitle})
          break;
        case 'collectionpages':
          des += this.$t('unpublish.collectionPagesDesc', {pageDefaultTitle: this.pageDefaultTitle})
          break;
      }
      return des
    },
    htmlDescNotification() {
      return `${this.$t("page.share.desc")}
      <a class="d-inline-flex align-items-center text-decoration-none" href="https://help.gempages.net/articles/transfer-templates-another-store" target="_blank">
        ${this.$t("page.share.helpCenter")}
        <svg class="ml-half" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M1.67725 1.67706H5.25016V2.98956H2.98975V11.0104H11.0106V8.74998H12.3231V12.3229H1.67725V1.67706Z" fill="currentColor" />
          <path fill-rule="evenodd" clip-rule="evenodd" d="M10.0827 2.98956H7.58366V1.67706H12.3234L12.3232 6.41666L11.0107 6.41663L11.0108 3.91766L6.2977 8.63069L5.36963 7.7026L10.0827 2.98956Z" fill="currentColor" />
        </svg>
      </a>`
    },
    isShowModalShareSocial() {
      return this.currentModel == 'share' && this.modelActive;
    },
    isGemPagesV7() {
      return (this && this.shopInfo && this.shopInfo.isGemPagesV7) || window.___gemShopInfo.isGemPagesV7 || false;
    },
    editorV7Url() {
      return Config.getSetting("instantBaseURL") + `/editor/${this.themeID}/${this.page.id}?type=gempagesv7`;
    },
  },
  watch: {},
  async created() {
    this.headerFooter = this.page.layout == "default" ? true : false;
    this.articleLayout = this.page.articleLayout == "inherit" ? true : false;
    this.pageTitle = this.page.title;
    this.pageDublicateTitle = "Copy of " + this.page.title;
    this.pageDublicateToTitle = "Duplicate from " + this.page.title;
    this.themeID = await getThemeId();
  },
  methods: {
    ...mapActions("group", {
      fetchGroups: "fetchGroups",
      createGroup: "createGroup"
    }),
    ...mapActions("page", {
      removePage: "deletePage",
      updatePageInfo: "updatePageInfo",
      clonePage: "clonePage",
      clonePageV2: "clonePageV2",
      setGroupID: "setGroupID",
      makeDefault: "makeDefault",
      linkPage: "linkPage",
      unlinkPage: "unlinkPage",
      duplicateTo: "duplicateTo",
      doModifyLayout: "modifyLayout",
      unpublishPage: "unpublishPage",
      fetchPages: "fetchPages"
    }),
    ...mapMutations("page", {
      resetFetchedPage: "RESET_FETCHED_PAGE"
    }),
    ...mapMutations({
      updatePageGroupID: "page/UPDATE_GROUP_ID"
    }),
    disabledDuplicateTo() {
      if (this.isOriginalShopifyPage() || this.isDefault()) {
        return true;
      }

      if (["subpages", "articlepages"].includes(this.pageType)) {
        if (this.page.isGpTemplate != true) {
          return true;
        }
      }
      return false;
    },
    onClickPageType(item) {
      this.selectedType = item;
      let $dropdown = this.$refs["select-page-dropdown"];
      if ($dropdown) $dropdown.closeDropdown();
    },
    onClickSetGroup(group) {
      this.selectedSetGroup = group;
      this.selectedGroupID = group.id;
    },
    openPreview() {
      if (this.isOriginalShopifyPage() && !["productpages", "collectionpages", "homepages"].includes(this.pageType)) return false;
      if (this.pageType == "subpages") {
        if (!this.page.isGpTemplate || this.page.gp_unlink) return;
      }
      if (this.pageType == "articlepages") {
        if (!this.page.isGpTemplate || this.page.gp_unlink) return;
      }
      this.previewPage();
    },
    previewPage() {
      if (this.page && this.page.previewUrl && this.page.previewUrl != "#") {
        window.open(this.page.previewUrl, "_blank");
      }
    },
    isBackToOriginal() {
      return this.textDefault[this.page.title] && this.page.published == false;
    },
    getFirstAssign() {
      if (this.page.assigns && this.page.assigns.length) {
        const assignsList = [...this.page.assigns].sort((a, b) => {
          if (a.isNew && !b.isNew) return -1;
          if (b.isNew && !a.isNew) return 1;
          if (a.isNew && b.isNew) {
            return new Date(b.updated_at) - new Date(a.updated_at);
          }
          return 0;
        });
        return assignsList[0];
      }
      return false;
    },
    copyURL() {
      let copyText = this.page.viewliveUrl;
      if (["productpages", "collectionpages"].includes(this.pageType)) {
        const productHandle = this.getFirstAssign().handle;
        const linkType = this.pageType == "productpages" ? "products" : "collections";
        copyText = `https://${this.shopInfo.shopifyDomain}/${linkType}/${productHandle}`;
      }

      copyToClipboard(copyText);

      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 1000);
    },
    shareFB() {
      let copyText = this.page.viewliveUrl;
      if (["productpages", "collectionpages"].includes(this.pageType)) {
        const productHandle = this.getFirstAssign().handle;
        const linkType = this.pageType == "productpages" ? "products" : "collections";
        copyText = `https://${this.shopInfo.shopifyDomain}/${linkType}/${productHandle}`;
      }
      let url = `https://www.facebook.com/sharer/sharer.php?u=${copyText}`;
      window.open(url, "pop", "width=600, height=400, scrollbars=no");
      return false;
    },
    changeToggler(val) {
      this.headerFooter = val;
    },
    changeTogglerArticle(val) {
      this.articleLayout = val;
    },
    isOriginalShopifyPage() {
      return this.textDefault[this.page.title] ? true : false;
    },
    doSubmit() {
      switch (this.currentModel) {
        case "duplicate":
          this.duplicatePage();
          break;
        case "duplicateTo":
          this.duplicatePageTo();
          break;
        case "delete":
          this.deletePage();
          break;

        case "hnf":
          if (this.permission.headerFooter) {
            this.updatePage();
          } else {
            this.$router.push({
              name: "Pricing",
              query: {
                from: "header_footer"
              }
            });
          }
          break;
        case "rename":
          this.updatePage();
          break;
        case "setgroup":
          this.setGroup();
          break;
        case "moveNewGroup":
          this.moveNewGroup();
          break;
        case "unLink":
          this.unLink();
          break;
        case "articleLayout":
          this.modifyLayout();
          break;
        case "unpublish":
          this.unpublish();
          break;
      }
      return "";
    },
    async modifyLayout() {
      this.gSnackbarCommit({
        message: this.$t("status.processing"),
        type: "loading"
      });

      try {
        let layout = "none";
        if (this.articleLayout) {
          layout = "inherit";
        }
        await this.doModifyLayout({
          id: this.page.id,
          type: this.pageType,
          layout: layout
        });
        this.gSnackbarCommit({
          message: "Success",
          type: "success"
        });
      } catch (error) {
        this.gSnackbarCommit({
          message: "Something went wrong",
          type: "error"
        });
      }

      this.modelActive = false;
    },
    async duplicatePageTo() {
      if (!this.selectedType) {
        this.alertText = "You should select page type";
        return;
      }
      this.alertText = "";
      if (this.pageDublicateToTitle.trim() == "") {
        this.alertTextDuplicate = "Page title name cannot be blank.";
        return;
      }
      this.alertTextDuplicate = "";
      let pType = this.selectedType.key;
      let type1 = "";
      let type2 = "";
      let newTitle = this.pageDublicateToTitle.trim();
      if (pType == "landingpages") {
        type1 = "template-page";
        type2 = "SubPages";
      }
      if (pType == "blog") {
        type1 = "template-article";
        type2 = "ArticlePages";
      }
      if (pType == "homepages") {
        type1 = "template-index";
        type2 = "HomePages";
      }
      if (pType == "productpages") {
        type1 = "template-product";
        type2 = "ProductPages";
      }
      if (pType == "collectionpages") {
        type1 = "template-collection";
        type2 = "CollectionPages";
      }

      this.gSnackbarCommit({
        message: this.$t("status.processing"),
        type: "loading"
      });

      try {
        await this.duplicateTo({
          id: this.page.id,
          to: type1,
          pageTitle: newTitle
        });
        this.gSnackbarCommit({
          message: "Success",
          type: "success"
        });
        this.$router.push({ name: type2 });
      } catch (error) {
        this.gSnackbarCommit({
          message: "Something went wrong",
          type: "error"
        });
      }
      this.selectedType = "";
      this.modelActive = false;
    },
    setGroup() {
      let value = true;
      let groupId = this.selectedGroupID;
      if (this.selectedGroupID == 0) {
        value = false;
        groupId = this.page.page_group_id;
      }
      this.gSnackbarCommit({
        message: this.$t("status.processing"),
        type: "loading"
      });
      this.setGroupID({
        data: [
          {
            id: this.page.id,
            value: value
          }
        ],
        group_id: groupId,
        pageType: this.pageType,
      })
        .then(() => {
          this.modelActive = false;
          this.gSnackbarCommit({
            message: "Success",
            type: "success"
          });
        })
        .catch(() => {
          this.modelActive = false;
          this.gSnackbarCommit({
            message: "Something went wrong",
            type: "error"
          });
        });
    },
    async unpublish() {
      if (this.isDisabledUnpublish) return;
      try {
        this.gSnackbarCommit({
          message: this.$t("status.processing"),
          type: "loading"
        });
        this.closeDropdown();
        this.closeModal(false);
        this.resetFetchedPage(this.pageType);
        await this.unpublishPage({ pageId: this.page.id, pageType: this.pageType });
        await this.fetchPages({ type: this.pageType });
        this.gSnackbarCommit({
          message: this.$t("status.success"),
          type: "success"
        });
      } catch (error) {
        const message = error?.response?.data?.message || "Error";
        this.gSnackbarCommit({
          message: this.getErrorMessage(message),
          type: "error"
        });
      }
    },
    closeDropdown() {
      let $dropdown = this.$refs.dropdown;
      if ($dropdown) $dropdown.closeDropdown();
    },
    openModal(modalType) {
      if (this.isDisabledUnpublish && modalType == 'unpublish') return;
      if (this.notAllow) return;
      if (this.isRunningAbTesting && modalType == "rename") return;
      if (this.isRunningAbTesting && modalType == "delete") {
        this.closeDropdown();
        this.$store.commit("page/OPEN_AB_TESTING_BLOCK_MODAL", this.page.runningCampaignId);
        return;
      }
      if (this.isGemPagesV7 && this.page.status === 'PUBLISHED' && modalType == "delete" ) {
        return;
      }
      if (this.isDefault() && (modalType == "delete" || modalType == "duplicateTo")) {
        return;
      }
      if (!this.page.isGpTemplate && modalType == "articleLayout") {
        return;
      }
      if (!this.page.isGpTemplate && modalType == "articleLayout") {
        return;
      }
      if (["subpages", "articlepages"].includes(this.pageType) && this.page.isGpTemplate != true && modalType == "duplicateTo") {
        return;
      }
      if (!this.isOriginalShopifyPage() || modalType == "share") {
        if (this.disabledShare && modalType == "share") {
          return;
        }
        this.closeDropdown();

        if (modalType == "setgroup") {
          this.fetchGroups({
            pageType: this.pageType,
            onSuccess: () => {},
            onError: () => {}
          });
        }
        if (modalType == "setgroup" && (!this.getGroups || !this.getGroups.length)) {
          modalType = "moveNewGroup";
        }
        this.modelActive = true;
        this.currentModel = modalType;
      }
    },
    moveNewGroup() {
      if (this.groupName.trim() == "") {
        this.alertText = "Group name cannot be blank.";
        return;
      }
      this.createGroup({
        pageType: this.pageType,
        pageId: this.page.id,
        name: this.groupName
      })
        .then(res => {
          this.modelActive = false;
          this.updatePageGroupID({ type: this.pageType, pageId: this.page.id, groupId: res.data.group.id });
        })
        .catch(() => {
          this.modelActive = false;
        });
    },
    publish() {
      let publishSuccess = this.$t("generals.linkSuccess");
      this.linkPage({
        id: this.page.id,
        onLoading: () => {
          this.gSnackbarCommit({
            message: this.$t("status.processing"),
            type: "loading"
          });
        },
        onSuccess: () => {
          if (this && this.gSnackbarCommit && this.$t) {
            this.gSnackbarCommit({
              message: publishSuccess,
              type: "success"
            });
          }
        },
        onError: err => {
          this.gSnackbarCommit({
            message: this.getErrorMessage(err),
            type: "error"
          });
        }
      })
        .then(() => {
          this.modelActive = false;
        })
        .catch(() => {
          this.modelActive = false;
        });
    },
    unLink() {
      let unLinkSuccess = this.$t("generals.unlinkSuccess");
      this.unlinkPage({
        id: this.page.id,
        type: this.pageType,
        onLoading: () => {
          this.gSnackbarCommit({
            message: this.$t("status.processing"),
            type: "loading"
          });
        },
        onSuccess: () => {
          if (this && this.gSnackbarCommit && this.$t) {
            this.gSnackbarCommit({
              message: unLinkSuccess,
              type: "success"
            });
          }
        },
        onError: err => {
          this.gSnackbarCommit({
            message: this.getErrorMessage(err),
            type: "error"
          });
        }
      })
        .then(() => {
          this.modelActive = false;
        })
        .catch(() => {
          this.modelActive = false;
        });
    },
    layoutDefaultStatus() {
      return this.makeDefaultPages.includes(this.page.type) ? true : false;
    },
    isDefault() {
      if (this.layoutDefaultStatus()) {
        return this.page.published ? true : false;
      }
    },
    isPublishScheduled() {
      if (!this.page.events) return false;
      return this.page.events.some(item => item.event == PAGE_EVENTS.PUBLISHED);
    },
    closeModal(userClose = true) {
      this.alertText = "";
      if (userClose) {
        this.pageTitle = this.page.title;
        this.retypeDelete = "";
        this.groupName = "";
      }
      this.modelActive = false;
    },
    onSetGroupID(value) {
      this.selectedGroupID = value;
    },
    duplicatePage() {
      if (this.pageDublicateTitle.trim() == "") {
        this.alertTextDuplicate = "Page title name cannot be blank.";
        return;
      }
      this.closeDropdown();
      this.closeModal(false);
      this.gSnackbarCommit({
        message: this.$t("status.processing"),
        type: "loading"
      });
      const msgError = this.$t("status.error");
      const textSuccess = this.$t("status.success");
      this.clonePageV2({
        page: this.page,
        type: this.pageType,
        pageTitle: this.pageDublicateTitle.trim(),
        onSuccess: () => {
          this.gSnackbarCommit({
            message: textSuccess,
            type: "success"
          });
        },
        onError: () => {
          this.gSnackbarCommit({
            message: msgError,
            type: "error"
          });
        }
      });
    },
    async deletePage() {
      let deleteTextConfirm = "confirm";
      if (this.$i18n.locale == "fr") {
        deleteTextConfirm = "confirmer";
      }
      if (this.retypeDelete.trim() != deleteTextConfirm) {
        this.alertText = this.$t("generals.confirm.retypeIncorrect");
        return;
      }
      this.closeDropdown();
      this.closeModal(false);
      this.gSnackbarCommit({
        message: this.$t("status.processing"),
        type: "loading"
      });
      let textSuccess = this.$t("status.success");
      let textError = this.$t("status.error");
      if (this.recentPages) {
        try {
          await this.$store.dispatch("dashboard/removeOneRecentPage", {
            page: this.page,
            type: this.pageType,
            shop: this.shopInfo.shopifyDomain
          });
          this.gSnackbarCommit({
            message: textSuccess,
            type: "success"
          });
        } catch (e) {
          this.gSnackbarCommit({
            message: textError,
            type: "error"
          });
        }

        return;
      }
      this.removePage({
        page: this.page,
        type: this.pageType,
        shop: this.shopInfo.shopifyDomain,
        onSuccess: () => {
          this.gSnackbarCommit({
            message: textSuccess,
            type: "success"
          });
        },
        onError: err => {
          // Show dialog
          let errData = err.response?.data;
          if (errData?.message == "belongToACampaign") {
            this.gDialogCommit({
              type: "error",
              message: "error.belongToACampaign",
              data: {
                id: errData?.data?.campaign?.id
              }
            });
          }

          this.gSnackbarCommit({
            message: textError,
            type: "error"
          });
        }
      });
    },
    async updatePage() {
      this.closeDropdown();
      if (this.pageTitle.trim() == "") {
        this.alertText = "Page title name cannot be blank.";
        return;
      }
      this.closeModal(false);
      this.gSnackbarCommit({
        message: this.$t("status.processing"),
        type: "loading"
      });
      let textSuccess = this.$t("status.success");
      let textError = this.$t("status.error");
      const pageType = this.pageType || getPageListName(this.page.type);

      if (this.recentPages && !this.isGemPagesV7) {
        this.page.id = this.page.gId
      }

      if (this.recentPages && this.isGemPagesV7) {
        await pageApi.updateThemePageApi({
          pageId: this.page.id ?? '',
          input: {
            name: this.pageTitle,
          }
        })
        this.gSnackbarCommit({
          message: textSuccess,
          type: "success"
        });
        this.page.title = this.pageTitle;
        
        return;
      }
      
      this.updatePageInfo({
        shop: this.shopInfo.shopifyDomain,
        page: this.page,
        type: pageType,
        headerFooter: this.headerFooter,
        newTitle: this.pageTitle,
        onSuccess: () => {
          this.gSnackbarCommit({
            message: textSuccess,
            type: "success"
          });
          this.page.title = this.pageTitle;
        },
        onError: err => {
          // Show dialog
          let errData = err.response.data;
          if (errData?.message == "belongToACampaign") {
            this.gDialogCommit({
              type: "error",
              message: "error.belongToACampaign",
              data: {
                id: errData?.data?.campaign?.id
              }
            });
          }
          this.gSnackbarCommit({
            message: textError,
            type: "error"
          });
        }
      });

    },
    moveToNewGroup() {
      this.currentModel = "moveNewGroup";
    },
    checkIsDefault() {
      if (this.disabledEdit || this.isRunningAbTesting) {
        return;
      }

      if (this.isOriginalShopifyPage()) {
        this.closeDropdown();
        this.$emit("preventOpenEditor", this.page);
      }
      if (this.isRunningAbTesting) {
        this.$store.commit("page/OPEN_AB_TESTING_BLOCK_MODAL", this.page.runningCampaignId);
        this.closeDropdown();
      }
    },
    async updateTitleDublicate(data) {
      if (Object.keys(data.pageDublicate).length === 0) return false;
      if (data.newTitle.trim() == "") {
        this.alertTextDuplicate = "Page title name cannot be blank.";
        return;
      }
      let textSuccess = this.$t("status.success");
      let textError = this.$t("status.error");
      let isSuccess = false;
      await this.updatePageInfo({
        shop: this.shopInfo.shopifyDomain,
        page: data.pageDublicate,
        type: data.pageType ?? this.pageType,
        headerFooter: data.headerFooter ?? this.headerFooter,
        newTitle: data.newTitle,
        onSuccess: () => {
          this.gSnackbarCommit({
            message: textSuccess,
            type: "success"
          });
          isSuccess = true;
        },
        onError: () => {
          this.gSnackbarCommit({
            message: textError,
            type: "error"
          });
          this.pageDublicateTitle = "Copy of " + this.page.title;
          this.pageDublicateToTitle = "Duplicate from " + this.page.title;
        }
      });
      return isSuccess;
    },
    clickMakeDefault() {
      if (this.disabledMakeDefault) {
        return;
      }

      this.$emit("onMakeDefault", this.isBackToOriginal());
      if (this.isRunningAbTesting) {
        this.closeDropdown();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.gp_dropdown {
  &:not(.initiating) {
    /deep/ .gp_dropdown-button {
      width: 40px;
      height: 40px;
      padding: unset;
      i {
        margin: unset;
      }
    }
  }
}

/deep/ .gp_base-select_container {
  background: $light1;
}

/deep/ .set-group-select {
  max-width: 360px;
  min-width: 360px;
}
.share-container {
  user-select: none;
  @include trans-all;
  .share-item {
    padding: 10px 8px;
    display: flex;
    align-items: center;
    cursor: pointer;
    &__txt {
      font-weight: 400;
      font-size: 14px;
      line-height: 150%;
      color: map-get($text-light-mode, 'high-contrast');;
      margin-left: 8px;
    }
    &:hover {
      @include trans-all;
      border-radius: 3px;
      background: rgba(0, 0, 0, 0.1);
    }
  }
}
/deep/ .gp_dropdown_list {
  min-width: 228px !important;
  margin-top: 10px;

  &.fr {
    width: 288px;
  }
}

/deep/ .select-page-dropdown {
  button {
    justify-content: space-between;
    @include trans-all;
    border-radius: unset;
    border: 1px solid transparent;

    &.active {
      border: 1px solid $dark3;
      svg {
        transform: rotate(0deg);
      }
    }
    p {
      color: $textLightModeDisabled;
    }
    svg {
      transform: rotate(-180deg);
      @include trans-all;
    }
  }
  .gp-dropdown-duplicate-to {
    width: 100% !important;
    top: 100% !important;
    margin-top: 0 !important;
    .gp_dropdown-item {
      display: flex;
      align-items: center;
      padding: 10px 16px;
      i {
        margin-right: 8px;
        font-size: 20px;
      }
      p {
        margin-bottom: 1px;
      }
    }
  }
}

.hf-image {
  min-height: 165px;
}
.group-list {
  max-height: 300px;
  .group-item {
    display: flex;
    align-items: center;
    padding: 8px 25px;
    @include trans-all;
    cursor: pointer;
    &:hover:not(.selected) {
      background: $light2;
    }
    &.selected {
      background: $textDarkModeHigh;
    }
    .content {
      .title {
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
        width: 330px;
        white-space: nowrap;
        overflow: hidden !important;
        text-overflow: ellipsis;
      }
    }
    i {
      font-size: 32px;
      margin-right: 13px;
    }
  }
}
.break-word {
  word-break: break-word;
}

.warn-info {
  background: rgba($mono1, 0.1);
}

.text-decor-none {
  text-decoration: none;
}
.header-footer-disable-toggle {
  justify-content: space-between;
  margin-top: 24px;
}
.full-image {
  width: 560px;
  height: 160px;
  margin-top: 5px;
}
.header-footer-content-upgrade {
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  margin-top: 16px;
  color: #676767;
  max-width: 468px;
  .desc2 {
    margin-top: 24px;
  }
}
.header-footer-label {
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #212121;
}
.header-footer-not-avaible-body {
  padding: 20px;
}
.header-footer-title {
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  color: #212121;
}
.toggle-header-footer-disable {
  height: 15px;
}
.header-footer-page-title-disable-child {
  font-size: 14px;
  line-height: 150%;
  color: #676767;
  b {
    color: #212121;
  }
}
</style>
